// utils/countryConfig.js - Configuration system for countries with fewer feeds

export const countryConfig = {
  australia: {
    info: {
      name: 'Australia',
      displayName: 'Australia',
      flag: '🇦🇺',
      slug: 'australia',
      route: '/australia',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Australia',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  },

  // brazil: {
  //   info: {
  //     name: 'Brazil',
  //     displayName: 'Brazil', 
  //     flag: '🇧🇷',
  //     slug: 'brazil',
  //     route: '/brazil',
  //     hasNewsItems: true,
  //     isActive: true
  //   },
  //   feeds: [
  //     {
  //       id: 'recent_news',
  //       name: 'Recent Updates',
  //       title: 'Recent News',
  //       apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Brazil',
  //       feedName: 'Recent Updates',
  //       branch: 'N/A',
  //       topic: 'N/A',
  //       buttonName: 'Doc',
  //       showOnHomePage: true,
  //       type: 'news'
  //     }
  //   ]
  // },

  canada: {
    info: {
      name: 'Canada',
      displayName: 'Canada',
      flag: '🇨🇦',
      slug: 'canada',
      route: '/canada',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Canada',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      },
      // {
      //   id: 'parliament_bills',
      //   name: 'Parliament Bills',
      //   title: 'Parliament Bills',
      //   apiParams: '&skip=0&schema=canada&table=parliament_bills&order_by=created_at',
      //   feedName: 'Parliament Bills',
      //   branch: 'Legislative',
      //   topic: 'N/A',
      //   buttonName: 'Bill',
      //   showOnHomePage: true,
      //   type: 'bills'
      // }
    ]
  },

  france: {
    info: {
      name: 'France',
      displayName: 'France',
      flag: '🇫🇷',
      slug: 'france',
      route: '/france',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=France',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  },

  italy: {
    info: {
      name: 'Italy',
      displayName: 'Italy',
      flag: '🇮🇹',
      slug: 'italy',
      route: '/italy',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Italy',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  },

  japan: {
    info: {
      name: 'Japan',
      displayName: 'Japan',
      flag: '🇯🇵',
      slug: 'japan',
      route: '/japan',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Japan',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  },

  mexico: {
    info: {
      name: 'Mexico',
      displayName: 'Mexico',
      flag: '🇲🇽',
      slug: 'mexico',
      route: '/mexico',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Mexico',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  },

  // russia: {
  //   info: {
  //     name: 'Russia',
  //     displayName: 'Russia',
  //     flag: '🇷🇺',
  //     slug: 'russia',
  //     route: '/russia',
  //     hasNewsItems: true,
  //     isActive: true
  //   },
  //   feeds: [
  //     {
  //       id: 'recent_news',
  //       name: 'Recent Updates',
  //       title: 'Recent News',
  //       apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Russia',
  //       feedName: 'Recent Updates',
  //       branch: 'N/A',
  //       topic: 'N/A',
  //       buttonName: 'Doc',
  //       showOnHomePage: true,
  //       type: 'news'
  //     }
  //   ]
  // },

  'south-africa': {
    info: {
      name: 'South Africa',
      displayName: 'South Africa',
      flag: '🇿🇦',
      slug: 'south-africa',
      route: '/south-africa',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=South Africa',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  },

  uk: {
    info: {
      name: 'United Kingdom',
      displayName: 'United Kingdom',
      flag: '🇬🇧',
      slug: 'uk',
      route: '/uk',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=United Kingdom',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      },
      // {
      //   id: 'parliament_bills',
      //   name: 'Parliament Bills',
      //   title: 'UK Parliament Bills',
      //   apiParams: '&skip=0&schema=united_kingdom&table=parliament_bills&order_by=created_at',
      //   feedName: 'UK Parliament Bills',
      //   branch: 'Legislative',
      //   topic: 'N/A',
      //   buttonName: 'Bill',
      //   showOnHomePage: true,
      //   type: 'bills'
      // }
    ]
  },

  ukraine: {
    info: {
      name: 'Ukraine',
      displayName: 'Ukraine',
      flag: '🇺🇦',
      slug: 'ukraine',
      route: '/ukraine',
      hasNewsItems: true,
      isActive: true
    },
    feeds: [
      {
        id: 'recent_news',
        name: 'Recent Updates',
        title: 'Recent News',
        apiParams: '&skip=0&schema=public&table=news_items&order_by=created_at&filter_column=country&filter_string=Ukraine',
        feedName: 'Recent Updates',
        branch: 'N/A',
        topic: 'N/A',
        buttonName: 'Doc',
        showOnHomePage: true,
        type: 'news'
      }
    ]
  }
};

// Helper functions to work with the config
export const getCountryConfig = (countrySlug) => {
  return countryConfig[countrySlug] || null;
};

export const getCountryInfo = (countrySlug) => {
  const config = getCountryConfig(countrySlug);
  return config ? config.info : null;
};

export const getCountryFeeds = (countrySlug) => {
  const config = getCountryConfig(countrySlug);
  return config ? config.feeds : [];
};

export const getHomePageFeeds = (countrySlug) => {
  const feeds = getCountryFeeds(countrySlug);
  return feeds.filter(feed => feed.showOnHomePage !== false);
};

export const getAllCountries = () => {
  return Object.keys(countryConfig);
};

export const getActiveCountries = () => {
  return Object.entries(countryConfig)
    .filter(([key, config]) => config.info.isActive)
    .map(([key, config]) => ({ slug: key, ...config.info }));
};

export const isCountryValid = (countrySlug) => {
  return countryConfig.hasOwnProperty(countrySlug);
};

export const hasNewsItems = (countrySlug) => {
  const info = getCountryInfo(countrySlug);
  return info ? info.hasNewsItems : false;
};

export const getCountryByName = (countryName) => {
  return Object.entries(countryConfig).find(
    ([key, config]) => config.info.displayName === countryName
  );
};

// Transform functions for compatibility with existing infrastructure
export const transformCountryFeedsForMobile = (countrySlug) => {
  const feeds = getCountryFeeds(countrySlug);
  return feeds.map(feed => ({
    id: feed.id,
    name: feed.name,
    displayType: 'normal',
    apiParams: feed.apiParams,
    feedBranch: feed.branch,
    feedTopic: feed.topic,
    buttonName: feed.buttonName,
    showOnHomePage: feed.showOnHomePage
  }));
};

export default countryConfig;